// @ts-ignore
import * as Sentry from '@sentry/react';
// @ts-ignore
// @ts-ignore
import { v4 as uuidv4 } from 'uuid';
import { CampaignProduct } from '../classes/campaignProduct/CampaignProduct';
import { Sanitized } from '../@types/sanitized';
// @ts-ignore
import { plainToClass, TransformFnParams } from 'class-transformer';
import { VideoImage } from '../classes/VideoImage/VideoImage';
import cloneDeep from 'lodash/cloneDeep';
import { BoostSourceUpload } from '../classes/BoostSourceUpload/BoostSourceUpload';
import { DurationOneWeekInDays } from '../components/inputs/select/Fields/Duration';
import { useHSContext } from '../contexts/HSContext';
import { usePromoContext } from '../contexts/PromoContext';
import { useSubscribeSaveContext } from '../contexts/SubscribeSaveContext';
import { useBoostLeadsContext } from '../contexts/BoostLeadsContext';
import { useBoostLeadsLandingPageContext } from '../contexts/BoostLeadsLandingPageContext';
import {
    leadsPlusCartController,
    leadsPlusCartControllerPath,
    leadsPlusController,
    leadsPlusControllerPath,
} from './leadsPlusUrls';
import { USD } from './currencyHelpers';
import { BoostAudienceGeoSource } from '../classes/BoostAudienceGeoSource/BoostAudienceGeoSource';
import { helixBoostController } from './lwHelpers';
import { useToast } from '@helix/toasts';
import { ToastAlertWithTimeOut } from '../components/BoostV2/interface/ToastAlertWithTimeOut';
import { currentContextParam } from './adminHelpers';
import { sanitizeLayoutString } from './layoutHelpers';

export const BoostLLPGated = 'listing_buyer';
export const BoostLLPUnGated = 'listing_impress';
export const MEDIA_TYPE_VIDEO = 2;
export const MEDIA_TYPE_IMAGE = 1;
export const MediaTypeName = 'media_type_id';
export const RetargetingCartString = 'audience_remarket';
export const GeoTargetingCartString = 'audience_new';
export const UpgradeToVideo = 'upgrade_image_to_video';
export const MODE_EDIT = 'Edit';
export const MODE_ADD = 'Add';

export const HSFetchServerErrorMessage =
    'Something went wrong updating your cart. Please wait a few minutes and try again.';
export const HSZoomInMessage = 'You are zoomed out too far. To see zip/postal codes zoom in.';
export const HSAWSVideoFetchFail =
    'Something went wrong uploading your video. Refresh the page and try again.';
export const FileSizeToLargeError =
    'The video you selected is too large please choose a video that is smaller than 500mb';
export const FileAspectRatioError =
    'The video you selected is not in a valid aspect ratio. Valid aspect ratios are 1:1, 9:16, or 16:9';
export const HSDefaultJSErrorMessage =
    "Something went wrong. Refresh the page and try again. If that doesn't work contact support and give them this number: ";
export const HSCannotConnectToFBMessage =
    'We were unable to connect to your facebook account. Refresh the page and try again.';

export const CampaignTypeOpenHouse = 'OpenHouse';
export const CampaignTypeListing = 'Listing';
export const CartCampaignTypeRecruiting = 'Recruiting';
export const CartCampaignTypeAgentPromo = 'AgentPromo';

// should correspond to the adtypes.  Conversion on the backend
export const CartItemSubTypeIsPriceReduced = 'is_price_reduced';
export const CartItemSubTypeIsComingSoon = 'is_coming_soon';
export const CartItemSubTypeIsRecentlySold = 'is_recently_sold';
export const CartItemSubTypeIsNew = 'is_new';
export const CartItemSubTypeOpenHouse = 'is_open_house';
export const CartItemSubTypeListing = 'listing';
export const CartItemSubTypeIsVirtualTour = 'is_virtual_tour';
export const CartItemSubTypeIsVirtualOpenHouse = 'is_virtual_openhouse';

export const BrandPrimaryColor = '#E5EDE7';
export const BrandIconColorClassSuffix = 'helix-brand';
export const LwPrimaryColor = '#236847';

export const BUY6GET6 = 'buy6get6';
export const BUY4GET2 = 'buy4get2';
export const BUY2GET1 = 'buy2get1';
export const isPromoCouponForAPromotionalProduct = (couponName: string | null): boolean =>
    BUY6GET6 === couponName || BUY4GET2 === couponName || BUY2GET1 === couponName;
export const getPromoCouponForAPromotionalProductTrialPeriod = (couponName: string): number => {
    if (BUY6GET6 === couponName) {
        return 12;
    }
    if (BUY4GET2 === couponName) {
        return 6;
    }
    if (BUY2GET1 === couponName) {
        return 3;
    }

    throw new Error(
        `getPromoCouponForAPromotionalProductTrialPeriod(${couponName}) only call on promotional coupons, not normal coupons`
    );
};

export const TRYLEADSPLUS199 = 'TRYLEADSPLUS199';
export const TRYLEADSPLUS299 = 'TRYLEADSPLUS299';

export const PromoString = 'promo';
export const CartTypeAgentString = 'agent';

export const ShowBillingModal = 'showBillingModal';
export const ShowEditGeoUrlModal = 'showBillingModal';

export const PlatformListPrice = 'platform_list_price';

export const OpenhouseId = 'openhouse_id';

export const CampaignType = 'campaign_type';

export const isOpenHouse = (campaignType: string): boolean =>
    campaignType === CampaignTypeOpenHouse;

export const STATUS_ACTIVE_AUTO_RENEW = 'ACTIVE_AUTO_RENEW';
export const STATUS_ACTIVE_NO_AUTO_RENEW = 'ACTIVE_NO_AUTO_RENEW';
export const STATUS_PAUSED = 'PAUSED';
export const STATUS_DISABLED = 'DISABLED';
export const STATUS_ENDED = 'ENDED';
export const STATUS_ARCHIVED = 'ARCHIVED';
export const DISABLED = 'Disabled';

export const BOOST_SHORTCODE = 'boost';
export const BOOST_CUSTOMER_ID = 1169;
export const LEADGEN_SHORTCODE = 'leadgen';
export const LEADGEN_CUSTOMER_ID = 2003;

export const BACKEND_STRIPE_ERROR_MESSAGE_EMAIL_CURRENTLY_IN_USE =
    'Email address already in use.  Please login or select a new account email address.';

export const HSCustomClientErrorMessages = [
    HSFetchServerErrorMessage,
    HSAWSVideoFetchFail,
    HSCannotConnectToFBMessage,
    FileSizeToLargeError,
];

export const BillingDrawer = 'billing-drawer';
export const EditBillingText = 'edit-billing';
export const LeadsPlusBilling = 'leads-plus-billing';

export const automateSaveCheckboxChecked = 'automateSaveCheckboxChecked';
export const automateSaveRadioSelected = 'automateSaveRadioSelected';
export const showAutomateSaveSelectionModal = 'showAutomateSaveSelectionModal';

export const couponForNewBoostAgentAndSS = 'NEWTOBOOST&SAVE';
export const couponForNewBoostAgentAndSSDiscountDollars = 65;

export const calculateDiscountedTotalDueToSubSaveSignup = (
    price_in_dollars: number,
    current_discount: number,
    welcomeCouponUsed: boolean
): number => {
    const total = welcomeCouponUsed
        ? price_in_dollars - couponForNewBoostAgentAndSSDiscountDollars
        : price_in_dollars * ((100 - current_discount) / 100);
    return Math.max(0, Math.round(total));
};

export const discountMap = { 5: 32, 4: 15, 3: 12, 2: 10, 1: 8, 0: 0 };
export const discountToCouponMap = {
    32: couponForNewBoostAgentAndSS,
    15: 'SubscribeSaveTier1',
    12: 'SubscribeSaveTier2',
    10: 'SubscribeSaveTier3',
    8: 'SubscribeSaveTier4',
    0: '',
};

export const couponMap = {
    5: couponForNewBoostAgentAndSS,
    4: 'SubscribeSaveTier1',
    3: 'SubscribeSaveTier2',
    2: 'SubscribeSaveTier3',
    1: 'SubscribeSaveTier4',
    0: '',
};

export const WELCOME_2_BOOST_COUPON_CODE = 'NEWTOBOOST50';

export const ERROR_TYPE_STRIPE = 'stripe';

export const MAX_GEOS = 5;

export const CARD_WIDTH = 195.2;
export const MOBILE_CARD_WIDTH = CARD_WIDTH * 0.8166;
export const CARD_HEIGHT = 254;

export const automateSaveSelection = (
    supportsJustSolds: boolean,
    supportsPriceReduced: boolean,
    automateSaveSubscriptionArray: string[],
    hasWelcomeCoupon: boolean = false
) => {
    let automateSaveSubscriptionArrayLength = 0;
    if (automateSaveSubscriptionArray.includes('OpenHouse')) {
        automateSaveSubscriptionArrayLength += 1;
    }
    if (automateSaveSubscriptionArray.includes('Listing')) {
        automateSaveSubscriptionArrayLength += 1;
    }
    if (supportsPriceReduced && automateSaveSubscriptionArray.includes('PriceReduced')) {
        automateSaveSubscriptionArrayLength += 1;
    }
    if (supportsJustSolds && automateSaveSubscriptionArray.includes('RecentlySold')) {
        automateSaveSubscriptionArrayLength += 1;
    }

    // if none selected, then return 0
    if (automateSaveSubscriptionArrayLength < 1) {
        return { discount: 0, couponCodeToUse: null, totalSelected: 0 };
    }

    // total available subscribes is always 2 (new and oh) + 1 each for pr and sold if supported
    const totalAvailableSubscribes = [
        supportsJustSolds ? 1 : 0,
        supportsPriceReduced ? 1 : 0,
    ].reduce((previousValue, currentValue) => previousValue + currentValue, 2);

    if (totalAvailableSubscribes < automateSaveSubscriptionArrayLength) {
        throw new Error("You can't have more selected than there are total available!");
    }

    const useWelcomeSaveCoupon = automateSaveSubscriptionArrayLength > 0 && hasWelcomeCoupon;

    const discountIndex = 4 - (totalAvailableSubscribes - automateSaveSubscriptionArrayLength);
    const discount = discountMap[discountIndex];
    const couponCodeToUse = useWelcomeSaveCoupon ? couponMap[5] : couponMap[discountIndex];

    return { discount, couponCodeToUse, totalSelected: automateSaveSubscriptionArrayLength };
};

/*
used to establish discount value. 32 is when Welcome coupon and automate save is in play.
 */
export const startingAutomateSaveDiscountValue = (couponCode: string = null): number =>
    couponCode === WELCOME_2_BOOST_COUPON_CODE ? 32 : 15;

export const discountSubText =
    'Save up to 15% on all image ads when subscribing to automatically boosting them. No fees. Cancel anytime.';
export const timeSubText =
    "Let Boost do the work for you. We'll automatically run every ad at your brokerage discounted price. No fees. Cancel anytime.";

export const redirectToUrl = (url: string, allowBack: boolean = true): void => {
    if (!allowBack) {
        window.location.replace(url);
    } else {
        window.location.href = url;
    }
};

export const basepath = (): string => {
    if (window.location.pathname.match('/dashboard/easy_promo_checkout')) {
        return '/dashboard/easy_promo_checkout';
    }
    if (window.location.pathname.match('/easy_promo_checkout')) {
        return '/easy_promo_checkout';
    }

    if (window.location.pathname.match(leadsPlusCartControllerPath)) {
        return leadsPlusCartControllerPath;
    }

    if (window.location.pathname.match(leadsPlusCartController)) {
        return `/${leadsPlusCartController}`;
    }

    if (window.location.pathname.match(leadsPlusControllerPath)) {
        return leadsPlusControllerPath;
    }

    if (window.location.pathname.match(leadsPlusController)) {
        return `/${leadsPlusController}`;
    }

    if (window.location.pathname.match('/dashboard/agent')) {
        return '/dashboard/agent';
    }

    if (window.location.pathname.match('/dashboard/')) {
        return `/dashboard/easy_checkout`;
    }
    if (window.location.pathname.match('/easy_checkout/')) {
        return `/easy_checkout`;
    }

    if (window.location.pathname.match('/agent')) {
        return '/agent';
    }
    if (window.location.pathname.match(`/${helixBoostController}/settings`)) {
        return `/${helixBoostController}/settings`;
    }

    return window.location.pathname;
};

export const urlParams = new URLSearchParams(window.location ? window.location.search : []);

export const appendParamToURL = (url: string, paramName: string, paramValue: string): string => {
    const urlObject = new URL(url, window.location.origin);
    urlObject.searchParams.append(paramName, paramValue);
    return url.startsWith('http') ? urlObject.toString() : urlObject.pathname + urlObject.search;
};

// should always have context otherwise will be undefined and cause issues on dashboard
export const getCurrentContext = (): string | null =>
    urlParams.has(currentContextParam)
        ? urlParams.get(currentContextParam)
        : (document.body.dataset.currentContext ?? null);

export const viewingAsAgentIdParam = 'viewing_as_agent_id';
export const viewingAsOfficeIdParam = 'viewing_as_office_id';
export const viewingAsBrokerIdParam = 'viewing_as_broker_id';

export const getViewingAsAgentId = (): string | null =>
    urlParams.has(viewingAsAgentIdParam) ? urlParams.get(viewingAsAgentIdParam) : null;

export const objectFlip = (obj) =>
    Object.keys(obj).reduce((ret, key) => {
        ret[obj[key]] = key;
        return ret;
    }, {});

export const isTrue = (checkedItem: any): boolean =>
    checkedItem === '1' || checkedItem === 1 || checkedItem === 'true' || checkedItem === true;

export const validateEmail = (email: string): boolean => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
};

export const getBillingEmailAddressValue = (
    frontEndStripeDataFields: { email_address?: string } | null,
    cartItem: { email_address?: string } | null
): string => {
    if (validateEmail(frontEndStripeDataFields?.email_address)) {
        return frontEndStripeDataFields.email_address;
    }
    if (validateEmail(cartItem?.email_address)) {
        return cartItem.email_address;
    }
    return '';
};

export const cartTypeSelector = () => {
    const basePathValue = basepath();
    if (
        basePathValue === '/dashboard/easy_promo_checkout' ||
        basePathValue === '/easy_promo_checkout'
    ) {
        return PromoString;
    }

    if (
        basePathValue === '/dashboard/agent' ||
        basePathValue === '/agent' ||
        basePathValue === `/${helixBoostController}/settings` ||
        basePathValue.includes(`/${helixBoostController}/automateandsave`) ||
        basePathValue.includes(`/${helixBoostController}/paymentmethods`)
    ) {
        return 'agent';
    }

    if (
        basePathValue === leadsPlusCartControllerPath ||
        basePathValue === leadsPlusControllerPath ||
        basePathValue === '/leads_plus_cart' ||
        basePathValue === '/leads_plus' ||
        basePathValue === '/sales/geolookup' ||
        basePathValue.includes('/leadsplus/subscription')
    ) {
        return 'leads';
    }

    if (
        basePathValue === '/home-value' ||
        basePathValue === '/home-value/index.php' ||
        basePathValue === '/marketreport'
    ) {
        return 'boostLeadsLandingPage';
    }

    return 'listing';
};

/**
 * @deprecated Use useContextSelector instead to improve performance and avoid unnecessary re-renders.
 */
export const contextSelector = () => {
    let context;
    const cartType = cartTypeSelector();
    if (cartType === PromoString) {
        context = usePromoContext();
    } else if (cartType === 'agent') {
        context = useSubscribeSaveContext();
    } else if (cartType === 'leads') {
        context = useBoostLeadsContext();
    } else if (cartType === 'boostLeadsLandingPage') {
        context = useBoostLeadsLandingPageContext();
    } else {
        context = useHSContext();
    }
    return context;
};

export const getCartItemSubTypeTitle = (cartItem) => {
    if (cartItem.campaign_type === CampaignTypeListing) {
        if (cartItem.is_price_reduced) {
            return 'Price improvement';
        }

        if (cartItem.is_recently_sold) {
            return 'Recently sold';
        }

        if (cartItem.is_virtual_tour) {
            return 'Virtual tour';
        }

        if (cartItem.is_new) {
            return 'New listing';
        }

        return CampaignTypeListing;
    }

    if (cartItem.is_virtual_openhouse) {
        return 'Virtual open house';
    }

    if (cartItem.campaign_type === CampaignTypeOpenHouse) {
        return 'Open house';
    }
};

export const getBoostCartSlug = (): string | null => {
    const el: HTMLElement = document.getElementById('cartId');

    if (!el || !el.dataset) {
        console.warn('CartId is missing!');
        return null;
    }

    return el.dataset.cartId;
};

export const getCampaignID = (): string =>
    document.getElementById('campaignId')?.dataset?.campaignId ?? null;

/**
 * Returns the controller name from the DOM
 */
export const getControllerFunctionNameFromURL = (): string | null => {
    const el: HTMLElement = document.getElementById('controllerName');

    const pathArray: Array<string> = window.location.pathname.split('/');

    // This doesn't work on launchpad in production!
    const pathControllerName = pathArray[3];

    if (!el || (!el.dataset && !pathControllerName)) {
        return null;
    }

    let { controllerName } = el.dataset;

    // Why this extra fallback? Paranoia.
    if (!controllerName) {
        controllerName = pathControllerName;
    }

    return controllerName;
};

/**
 * Returns the customer shortcode
 */
export const getCustomerShortCode = (): string | null => {
    const el: HTMLElement = document.getElementById('shortCode');

    const pathArray: Array<string> = window.location.pathname.split('/');
    const pathShortCode = pathArray[4];

    if (!el || (!el.dataset && !pathShortCode)) {
        return null;
    }

    let { shortCode } = el.dataset;

    if (!shortCode) {
        shortCode = pathShortCode;
    }

    return shortCode;
};

export const getChoosePlanNewData = (): object | null => {
    const el: HTMLElement = document.getElementById('easy-checkout__initial-cart-data--js');

    if (!el || !el.innerHTML) {
        return null;
    }

    return JSON.parse(el.innerHTML);
};

export const sendError = (e: Error): void => {
    try {
        Sentry.captureException(e);
    } catch (e) {
        // do nothing - don't crash if we fail to report an error
    }
};

/**
 * Sentry notice for expected-but-notable events - a declined card, a user who
 * can't get past a form gate - which we want to be able to search and alert on
 * without them paging anyone as exceptions.
 */
export const sendWarning = (message: string): void => {
    try {
        Sentry.captureMessage(message, 'warning');
    } catch (e) {
        // do nothing - don't crash if we fail to report an error
    }
};

/**
 * Dates don't work correctly when converted from our backend in safari
 * @param dateString
 */
export const convertBackendDateStringToUtcDate = (dateString: string): Date => {
    // did someone pass an already compliant dateString? If so return it with no modifications
    const correctPattern = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)$/;
    if (correctPattern.test(dateString)) {
        return new Date(dateString);
    }

    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
    // we send the date time to the front end looking like "2022-08-25 16:30:00" which isn't compliant, should be YYYY-MM-DDTHH:mm:ss.sssZ
    // This extra check ensures that strings missed by `.test()` (e.g., missing `.000Z`) are still handled correctly.
    const compliantDateString = dateString?.trim().replace(' ', 'T');
    const postString = compliantDateString.includes('.000Z') ? '' : '.000Z';
    return new Date(`${compliantDateString}${postString}`);
};

export const convertDateStringToUtcDate = (params: TransformFnParams): Date => {
    const { value, key, obj } = params;

    if (!obj || !obj[key]) {
        return value || params;
    }

    // Skip if obj[key] is a plain object (not a Date)
    if (typeof obj[key] !== 'string') {
        return value;
    }

    let date = value;
    try {
        date = convertBackendDateStringToUtcDate(obj[key]);
    } catch (e) {
        sendError(
            new Error(
                `convertDateStringToUtcDate failed: value: ${value} (typeof ${typeof value}), obj[key]: ${
                    obj[key]
                } (typeof ${typeof obj[key]}): ${(e as Error).message}`
            )
        );
    }
    return date;
};

export const getBaseUrl = (): string => window.location.origin;

export const getEZCheckoutControllerBaseURL = (): string => getBaseUrl() + basepath();

export const getEZPromoCheckoutControllerBaseURL = (): string => getBaseUrl() + basepath();

export const getLWConnectURL = (customerId: number): string | null =>
    customerId === BOOST_CUSTOMER_ID ? `${getBaseUrl()}/dashboard/lwauth/connect/boost` : null;

export const getCampaignDetailPageURL = (): string =>
    `${getBaseUrl()}/dashboard/boost/detail/${getCustomerShortCode()}/${getCampaignID()}${
        window.location.search
    }`;

export const formatCurrency = (amount: number, numberOfDecimals: number = 2): string => {
    if (amount % 1 === 0) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: USD,
            minimumFractionDigits: numberOfDecimals,
            maximumFractionDigits: numberOfDecimals,
        }).format(amount);
    }

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: USD,
        minimumFractionDigits: 2,
    }).format(amount);
};

export const formatNumber = (amount: number, numberOfDecimals: number = 2): string =>
    new Intl.NumberFormat('en-US', {
        minimumFractionDigits: numberOfDecimals,
    }).format(amount);

export const roundNearest = (num, acc) => {
    if (acc < 0) {
        return Math.round(num * acc) / acc;
    }
    return Math.round(num / acc) * acc;
};

export const roundDownToNearest10 = (num: number): number => Math.floor(num / 10) * 10;

export const buildFormData = (formData, data, parentKey = null) => {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
    }
};

export const track = (key: string, data?: object): void => {
    // todo what do we want to do going forward?
};

const oneWeekInSeconds = 604800;

export const secondsToDays = (seconds: number) => seconds / (oneWeekInSeconds / 7);

/**
 * Count number of contact uploads
 * @param uploads
 */
export const getNumberOfContactsForSources = (uploads: BoostSourceUpload[] | null): number =>
    uploads ? uploads.reduce((a, b) => Number(a) + (Number(b.valid_rows) || 0), 0) : 0;

export const getGeosAsString = (geos: BoostAudienceGeoSource[] | null): string => {
    if (!geos || geos.length <= 0) {
        return '';
    }
    return geos
        ?.map((geo) => geo.name)
        .join(', ')
        .replace(/, (United States|Canada)/g, '');
};

export const getAudienceString = (
    geos: BoostAudienceGeoSource[] | null,
    uploads: BoostSourceUpload[] | null
): string => {
    const numberOfContacts = getNumberOfContactsForSources(uploads);
    const geoString = getGeosAsString(geos);

    if (geoString && numberOfContacts > 0) {
        return `${numberOfContacts} contacts and ${geoString}`;
    }

    if (geoString && numberOfContacts <= 0) {
        return geoString;
    }

    if (!geoString && numberOfContacts > 0) {
        return `${numberOfContacts} contacts`;
    }

    return ''; // doesn't seem like this should ever happen...
};

export const daysToSeconds = (days: number) => days * (oneWeekInSeconds / 7);

export const monthsToSeconds = (months: number) => months * 30 * (oneWeekInSeconds / 7);

export const secondsToMonths = (seconds: number) => seconds / monthsToSeconds(1);

export const getRootPath = () =>
    `${basepath()}/${getControllerFunctionNameFromURL()}/${getCustomerShortCode()}/${getBoostCartSlug()}`;

export const getBoostLeadCheckoutRootPath = () =>
    `${basepath()}/${getControllerFunctionNameFromURL()}/${getBoostCartSlug()}`;

export const handleFetchError = (response) => {
    if (!response?.ok) {
        Sentry.captureException(new Error(`HSFetch Error. Response: ${JSON.stringify(response)}`));
        throw Error(HSFetchServerErrorMessage);
    }

    return response;
};

// if you use this function make sure you catch any errors and deal with them
export const HSFetch = (
    postURL: string,
    body: ReadableStream | string | File | FormData | Sanitized.BoostSourceUpload,
    headers = {},
    mode = 'cors' as RequestMode,
    signal?: AbortSignal
): Promise<Response> =>
    fetch(postURL, {
        method: 'POST',
        // @ts-ignore
        body,
        headers: new Headers(headers),
        mode, // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // *default, no-cache, reload, force-cache, only-if-cached
        signal,
    }).then(handleFetchError);

// if you use this function make sure you catch any errors and deal with them
export const AWSPut = (url: string, file: File): Promise<Response> =>
    fetch(url, {
        method: 'PUT',
        mode: 'cors',
        cache: 'no-cache',
        body: file,
    }).then(handleFetchError);

export const useThrowFetchError = (): {
    throwFetchError: (error: Error, showMessage?: boolean) => void;
} => {
    const { addToast } = useToast();
    // If it's not one of the error messages we might expect...
    const throwFetchError = (error: Error, showMessage = false): void => {
        if (!HSCustomClientErrorMessages.includes(error.message) && !showMessage) {
            const uuid = uuidv4();
            Sentry.captureException(new Error(`${error.message}: ${uuid}`)); // we already captured fetch fails above
            // Do we want to throw all visible JS errors to the end-user? Probably not, but this would put something actionable for devs to respond to in screenshots!
            ToastAlertWithTimeOut(addToast, false, `${HSDefaultJSErrorMessage} ${uuid}`);
        } else {
            ToastAlertWithTimeOut(addToast, false, error.message, error, 15000);
            track('EZCFetchFail');
        }
    };
    return { throwFetchError };
};

export const useHandleFbPageError = () => {
    const { throwFetchError } = useThrowFetchError();

    const handleFbPageError = (message: string, pageID: string): void => {
        const isLoadingRequest = message.includes('A request to access page');

        throwFetchError(
            new Error(
                isLoadingRequest
                    ? message
                    : `We were unable to connect your Facebook page, ${pageID}, to the ad, but our support team can help you resolve this quickly!`
            ),
            true
        );
    };
    return { handleFbPageError };
};

export const MAX_FILE_SIZE = 524288000; // 500 mb in bytes

export const isVideoOnHomeSpotterBucket = (url: string) => {
    if (url && url.length) {
        return (
            url.includes('https://homespotter-upload.s3.amazonaws.com/') ||
            url.includes('https://homespotter-upload-staging.s3.amazonaws.com/')
        );
    }

    return false;
};

// helper
export const cloneString = (inStr: string): string => JSON.parse(JSON.stringify(inStr));

/**
 * Video images deep copy, if you set multiple states with the same variable, they still all point to the same location in memory, so you need to clone objects before setting state in these instances
 * @param videoImages
 * @protected
 */
export const cloneVideoImages = (
    videoImages: Array<Sanitized.VideoImage>
): Array<Sanitized.VideoImage> => {
    const videoImagesCloned = [];

    videoImages.map((el, index) => {
        const clone = JSON.parse(JSON.stringify(el));
        videoImagesCloned.push(plainToClass(VideoImage, clone));
    });

    return videoImagesCloned;
};

/**
 *
 * @param url
 */
export const getHighQualityPhotoUrl = (url: string): string => {
    const getLargeHomeSpotterImageFromMedium = (imageSource): string => {
        const re = /\/m\//;
        return imageSource.replace(re, '/l/');
    };

    const isHomeSpotterImage = (imageSource): boolean => {
        const re = /\/(d3h1b6nzz0wqnl.cloudfront.net|listing-images.homespotter.com)/;
        return re.test(imageSource);
    };

    if (isHomeSpotterImage(url)) {
        return getLargeHomeSpotterImageFromMedium(url);
    }

    return url;
};

/**
 * Count the platforms with spend
 * @param spendRatioToCount
 */
const countNumberOfPlatforms = (spendRatioToCount: Sanitized.spendRatioObject): number =>
    Math.ceil(spendRatioToCount.display_spend) +
    Math.ceil(spendRatioToCount.facebook_spend) +
    Math.ceil(spendRatioToCount.nextdoor_spend) +
    Math.ceil(spendRatioToCount.google_spend);

/**
 * return 2 platforms if spend ratio is not cool
 * @param spendRatioToCount
 */
export const countNumberOfPlatformsOrDefault = (
    spendRatioToCount: Sanitized.spendRatioObject | null
): number => {
    if (spendRatioToCount) {
        return countNumberOfPlatforms(spendRatioToCount);
    }
    return 2;
};

export const hasNextdoorEnabled = (spendRatio: Sanitized.spendRatioObject): boolean =>
    spendRatio.nextdoor_spend > 0;

export const assertSpendRatioIsValid = (spendRatio: Sanitized.spendRatioObject): void => {
    const sum =
        spendRatio.display_spend +
        spendRatio.facebook_spend +
        spendRatio.nextdoor_spend +
        spendRatio.google_spend;
    if (sum !== 1) {
        throw new Error('spend ratio should sum to 1');
    }
};

export const adIsOnlyWebSpend = (spendRatio: Sanitized.spendRatioObject): boolean => {
    assertSpendRatioIsValid(spendRatio);
    return spendRatio.display_spend === 1;
};

/**
 * Get the CampaignProduct for a given audienceSize, duration, and mediaTypeID
 * @param priceMatrix
 * @param multiplier
 * @param durationInDays
 * @param campaignType
 * @param mediaTypeID
 * @param isIncreaseExposure
 * @param VideoUpgradeMinimumPrice
 * @param numberOfPlatforms
 */
export const getProductRaw = (
    priceMatrix: CampaignProduct[],
    multiplier: number,
    durationInDays: number,
    campaignType: string,
    mediaTypeID: number,
    numberOfPlatforms: number,
    isIncreaseExposure: boolean = false,
    VideoUpgradeMinimumPrice: number = 0
): CampaignProduct => {
    if (multiplier < 1 || multiplier > 10) {
        throw new Error(`Multiplier must be int between 1-10, it was: ${multiplier}`);
    }
    if (campaignType !== CampaignTypeOpenHouse && (durationInDays < 0 || durationInDays > 28)) {
        throw new Error(`Duration must be int between 0-28, it was: ${durationInDays}`);
    }

    let newDurationInDaysForFindingProduct = Number(durationInDays);
    // What on earth?
    // So down below we use the duration int to find the associated CampaignProduct in the priceMatrix, there isn't any value for "0"
    // that's just used for increase exposure campaigns that don't want to extend the end date of the campaign, but still want to increase the budget
    // So since we don't return or use the durationInDays variable, we mutate it here after gating for valid input.
    if (isIncreaseExposure && durationInDays === 0 && campaignType === CampaignTypeListing) {
        newDurationInDaysForFindingProduct = 7;
    }

    if (newDurationInDaysForFindingProduct < 7 && campaignType === CampaignTypeListing) {
        // Our pricing structure design says listing ads under 7 days ALL GET 7 day pricing (similarly for OH's (~3 days))!
        newDurationInDaysForFindingProduct = 7;
    }

    // GetProducts
    function getCampaignProductToReturn(): CampaignProduct {
        return priceMatrix.find((val) => {
            // duration is number of weeks in seconds
            // media_type_id 1 is image, 2 is video
            if (
                (secondsToDays(val.durationInSeconds) === newDurationInDaysForFindingProduct ||
                    campaignType === CampaignTypeOpenHouse) &&
                Number(mediaTypeID) === val.media_id &&
                numberOfPlatforms === val.number_of_platforms
            ) {
                return val;
            }
        });
    }

    // find will return undefined if it doesn't find something that meets its criteria.
    const campaignProductToReturn = getCampaignProductToReturn();

    if (!campaignProductToReturn) {
        sendError(
            new Error(
                `Failed to find product for ${campaignType}, IE ${isIncreaseExposure}, duration ${newDurationInDaysForFindingProduct}, media ${mediaTypeID}, numPlatforms ${numberOfPlatforms} in ${JSON.stringify(
                    priceMatrix
                )}`
            )
        );
    }

    // Set the campaign product with a duration of 0 so we know that this is an increase exposure without pushing out the end date.
    if (isIncreaseExposure) {
        const campaignProductCopyToReturn = plainToClass(
            CampaignProduct,
            cloneDeep(campaignProductToReturn)
        ) as CampaignProduct;

        const price = applyMultiplier(campaignProductCopyToReturn.seedPriceInDollars, multiplier);

        if (
            VideoUpgradeMinimumPrice > 0 &&
            price - VideoUpgradeMinimumPrice > 0 &&
            mediaTypeID === MEDIA_TYPE_VIDEO
        ) {
            campaignProductCopyToReturn.videoDiscountString = formatCurrency(
                (VideoUpgradeMinimumPrice ?? 0) / 100
            );
            // campaignProductCopyToReturn.price = campaignProductCopyToReturn.price - VideoUpgradeMinimumPrice;
        } else {
            campaignProductCopyToReturn.videoDiscountString = undefined;
        }

        campaignProductCopyToReturn.durationInSeconds = daysToSeconds(durationInDays);
        return campaignProductCopyToReturn;
    }

    return campaignProductToReturn;
};

export const formatDate = (
    date: Date,
    options?:
        | 'dayDateTime'
        | 'dateNoTime'
        | 'dateTime'
        | 'shortDate'
        | 'dateTimeWithYear'
        | 'weekdayDate'
        | 'weekdayDateTime'
): string => {
    const formatOptions: Intl.DateTimeFormatOptions = {};

    switch (options) {
        case 'dayDateTime':
            Object.assign(formatOptions, {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            });
            break;
        case 'dateNoTime':
            Object.assign(formatOptions, {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            });
            break;
        case 'dateTime':
            Object.assign(formatOptions, {
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            });
            break;
        case 'dateTimeWithYear':
            Object.assign(formatOptions, {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            });
            break;
        case 'shortDate':
            Object.assign(formatOptions, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            });
            break;

        case 'weekdayDate':
            Object.assign(formatOptions, {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
            });
            break;

        case 'weekdayDateTime':
            Object.assign(formatOptions, {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            });
            break;
        default:
            Object.assign(formatOptions, {
                month: 'short',
                day: 'numeric',
            });
            break;
    }

    return new Intl.DateTimeFormat('en-US', formatOptions).format(date);
};

export const formatEndDate = (date: Date): string => {
    const endsAtDateString = formatDate(date, 'shortDate');
    // check also 12/30/9999 due to timezone issues with converting from utc to local
    return endsAtDateString.endsWith('/9999') ? 'Ongoing' : endsAtDateString;
};

/**
 * NOTE: You must make sure that this function stays in sync with the corresponding applyMultiplier function in the back end!
 * Kardell's pretty print algorithm
 * @param seedPrice
 * @param multiplier
 */
export const applyMultiplier = (seedPrice: number, multiplier: number): number => {
    seedPrice = Math.round(seedPrice);
    const lastDigit = seedPrice % 10;
    const lastDigitIs4Or9 = lastDigit === 9 || lastDigit === 4;
    const lastDigitIs5or0 = lastDigit === 5 || lastDigit === 0;
    const addSubtract = lastDigitIs4Or9 ? 1 : 0;

    const newPriceInDollars = lastDigitIs5or0
        ? Math.round(((seedPrice + addSubtract) * multiplier - addSubtract) / 5) * 5
        : (seedPrice + addSubtract) * multiplier - addSubtract;
    return Math.round(newPriceInDollars);
};

export const addDaysToDate = (date: Date, days: number): Date => {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
};

export const getDefaultDuration = (
    durationInDays: null | number,
    cartItem: Sanitized.CartItem
): number | null => {
    if (durationInDays) {
        return durationInDays;
    }
    if (cartItem.campaign_type === CampaignTypeListing) {
        return Number(DurationOneWeekInDays);
    }

    return null;
};

export const getSubType = (cartItem: Sanitized.CartItem | Sanitized.CartItem): string => {
    if (cartItem.campaign_type === CampaignTypeListing) {
        if (cartItem.is_price_reduced) {
            return CartItemSubTypeIsPriceReduced;
        }

        if (cartItem.is_coming_soon) {
            return CartItemSubTypeIsComingSoon;
        }

        if (cartItem.is_recently_sold) {
            return CartItemSubTypeIsRecentlySold;
        }

        if (cartItem.is_virtual_tour) {
            return CartItemSubTypeIsVirtualTour;
        }

        if (cartItem.is_new) {
            return CartItemSubTypeIsNew;
        }

        return CartItemSubTypeListing;
    }

    if (cartItem.is_virtual_openhouse) {
        return CartItemSubTypeOpenHouse;
    }

    if (cartItem.campaign_type === CampaignTypeOpenHouse) {
        return CartItemSubTypeOpenHouse;
    }
};

export const parseAndCatchJson = async (res: Response): Promise<any> => {
    const responseBody = await res.text();
    let parsedJson;
    try {
        parsedJson = JSON.parse(responseBody);
    } catch (e) {
        throw new Error(`${e} ${responseBody}`);
    }
    return parsedJson;
};

export const abTestById = (id: string): boolean => !!(parseInt(id.charAt(id.length - 1), 16) % 2);

export const getLLPPreviewBaseLink = (url: string, hostname: string): string => {
    const urlObject = new URL(url);
    const qaMatches = hostname.match(/qa(\d{1,2})-api/);
    if (qaMatches && qaMatches.length > 0) {
        return `https://qa${qaMatches[1]}-homes.homespotter.com${urlObject.pathname}`;
    }
    if (process.env.MODE === 'DEVELOPMENT') {
        return `https://local.homes.homespotter.com${urlObject.pathname}`;
    }
    return urlObject.origin + urlObject.pathname;
};

export const roundUpToTenThousands = (num: number): number => Math.round(num / 10000) * 10000;

export const roundDownToTenThousands = (num: number): number => Math.floor(num / 10000) * 10000;

export const getLeadBoostCurrentStatusText = (subscriptionStatus: string): string => {
    let status = '';
    if (
        subscriptionStatus === STATUS_ACTIVE_AUTO_RENEW ||
        subscriptionStatus === STATUS_ACTIVE_NO_AUTO_RENEW
    ) {
        status = 'Active';
    } else if (subscriptionStatus === STATUS_PAUSED) {
        status = 'Paused';
    } else if (subscriptionStatus === STATUS_ENDED) {
        status = 'Ended';
    } else if (subscriptionStatus === STATUS_DISABLED) {
        status = 'Disabled';
    } else if (subscriptionStatus === STATUS_ARCHIVED) {
        status = 'Archived';
    }
    return status;
};

export const getIntranetEnvironment = (windowLocation: string): string => {
    let origin = '';
    if (process.env.MODE === 'DEVELOPMENT') {
        origin = 'https://dev.intranet.homespotter.com/';
    } else if (windowLocation.includes('qa')) {
        const host = windowLocation.split('-')[0];
        origin = `${host}-intranet.homespotter.com/`;
    } else {
        origin = 'https://intranet.homespotter.com/';
    }
    return origin;
};

/**
 * The cartItem has counter-intuitive names, this re-names some stuff, (also this matches what save-preview-campaign expects, but in order to update the cart with another method this will need to be undone)
 * @param rawCartItem
 */
export const reformatCartItemResponse = (rawCartItem: any): Sanitized.CartItem => {
    const newRawCartItem = rawCartItem;
    newRawCartItem.headline = rawCartItem.campaign_headline;
    newRawCartItem.title = rawCartItem.campaign_title;
    newRawCartItem.description = rawCartItem.campaign_description;
    newRawCartItem.display_ads_details = rawCartItem.display_detail_text;
    newRawCartItem.display_ads_primary_text = rawCartItem.listing_image_primary_text;
    newRawCartItem.display_ad_secondary_text = rawCartItem.listing_image_secondary_text;
    newRawCartItem.is_price_reduced = isTrue(rawCartItem.is_price_reduced);
    newRawCartItem.is_new = isTrue(rawCartItem.is_new);
    newRawCartItem.is_coming_soon = isTrue(rawCartItem.is_coming_soon);
    newRawCartItem.is_recently_sold = isTrue(rawCartItem.is_recently_sold);
    newRawCartItem.item_size = Number(rawCartItem.item_size);
    newRawCartItem.media_type_id = Number(rawCartItem.media_type_id);
    newRawCartItem.custom_video_url = String(rawCartItem.custom_video_url ?? '');
    newRawCartItem.custom_listing_video_ad_url = String(
        rawCartItem.custom_listing_video_ad_url ?? ''
    );
    newRawCartItem.use_custom_upload = isTrue(rawCartItem.use_custom_upload);
    newRawCartItem.is_virtual_openhouse = isTrue(rawCartItem.is_virtual_openhouse);
    newRawCartItem.is_recently_sold = isTrue(rawCartItem.is_recently_sold);
    newRawCartItem.is_virtual_tour = isTrue(rawCartItem.is_virtual_tour);
    newRawCartItem.duration_in_days = Number(rawCartItem.duration_in_days);
    newRawCartItem.selected_fb_layout = sanitizeLayoutString(rawCartItem.selected_fb_layout);
    newRawCartItem.isListingCart = true;
    newRawCartItem.isPromoCart = false;

    return newRawCartItem;
};

export const reformatAgentResponse = (agent: any): any => {
    const agentData = agent || {};
    if (agent) {
        agentData.is_site_admin = isTrue(agent.is_site_admin);
        agentData.is_broker_admin = isTrue(agent.is_broker_admin);
        agentData.is_boost_admin = isTrue(agent.is_boost_admin);
        agentData.is_office_admin = isTrue(agent.is_office_admin);
    }
    return agentData;
};

/**
 * The cartItem has counter-intuitive names, this re-names some stuff, (also this matches what save-preview-campaign expects, but in order to update the cart with another method this will need to be undone)
 * @param responseData
 */
export const reformatPromoCartItemResponse = (response: any): Sanitized.PromoCartItem => {
    const responseData = response;
    responseData.cartItem.headline = response.cartItem.campaign_headline;
    responseData.cartItem.title = response.cartItem.campaign_title;
    responseData.cartItem.description = response.cartItem.campaign_description;
    responseData.cartItem.display_ads_details = response.campaign.display_ads_details;
    responseData.cartItem.display_ads_primary_text = response.campaign.listing_image_primary_text;
    responseData.cartItem.display_ad_secondary_text =
        response.campaign.listing_image_secondary_text;
    responseData.cartItem.social_ad_primary_text = response.cartItem.campaign_agent_name;
    // sets campaign_llp_url
    responseData.cartItem.campaign_llp_url =
        response.cartItem.campaign_llp_url ?? response.LLP.custom_llp_url;

    responseData.creative_template_id =
        response.cartItem.creative_template_id ?? response.CreativeOptions.creative_template_id;

    // sets target_audience based on values given
    responseData.cartItem.target_audience =
        response.Audiences.boostAudienceUploadSources &&
        response.Audiences.boostAudienceUploadSources.length > 0
            ? RetargetingCartString
            : GeoTargetingCartString;
    responseData.cartItem.include_custom_contacts =
        response.Audiences.boostAudienceUploadSources &&
        response.Audiences.boostAudienceUploadSources.length > 0;

    responseData.cartItem.include_spacio_contacts = isTrue(
        response.cartItem.include_spacio_contacts
    );
    responseData.cartItem.is_subscription = isTrue(response.cartItem.is_subscription);
    responseData.cartItem.duration_months = Number(response.cartItem.duration_months) ?? 1;
    responseData.cartItem.include_spacio_contacts = isTrue(
        response.cartItem.include_spacio_contacts
    );
    responseData.cartItem.media_type_id = Number(response.cartItem.media_type_id);
    responseData.cartItem.use_custom_upload = isTrue(response.cartItem.use_custom_upload);
    responseData.cartItem.is_subscription = isTrue(response.cartItem.is_subscription);
    responseData.cartItem.creative_template_id = Number(response.cartItem.creative_template_id);
    responseData.cartItem.use_lead_gen_form = isTrue(response.cartItem.use_lead_gen_form);
    responseData.cartItem.creative_template_id = Number(response.cartItem.creative_template_id);
    responseData.cartItem.isPromoCart = true;
    responseData.cartItem.isListingCart = false;

    return responseData.cartItem;
};

export const getGeoSourceString = (geoSource: Array<BoostAudienceGeoSource>): string => {
    if (geoSource?.length <= 0) {
        return ' N/A';
    }
    if (geoSource?.length === 1) {
        return ` ${geoSource[0]?.name}`;
    }
    const geoNames = geoSource.map((geo: BoostAudienceGeoSource) => `\n${geo?.name}`).join(' ');
    const geoNamesNoCountry = geoNames.replace(/, United States|, Canada/gi, '');
    return `: ${geoNamesNoCountry}\n`;
};

export const videoBackgroundAdjustForEdit = (backgroundUrl: string): string => {
    if (!backgroundUrl) {
        return '';
    }
    if (backgroundUrl.includes('web/')) {
        return backgroundUrl;
    }
    return backgroundUrl.replace('video/', 'video/web/');
};

export const getDomData = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
        const data = element.textContent;
        return JSON.parse(data);
    }
    return null;
};

export const getDataFromDOMForGlobalHeader = (): boolean => {
    const domData = getDomData('headerLinksJson');
    if (domData) {
        return domData?.hasEnabledLwId;
    }
    return false;
};

export const getDataValidationHeader = (key) => {
    const domData = getDomData('headerLinksJson');
    if (domData) {
        return domData ? domData[key] : null;
    }
    return null;
};

export const mysterymanurl =
    'https://mobilerealtyapps-agent-photos.s3.amazonaws.com/default/mysteryman_boost.jpg';

export const noAgentPhoto =
    'https://mobilerealtyapps-agent-photos.s3.amazonaws.com/default/no_agent_photo.png';

export const defaultCampaignImgUrl =
    'https://boost-custom-listing-images.s3.amazonaws.com/default.png';

export const getLastUpdateInfo = (
    lastUpdateTimestamp: string | null
): { isLastUpdateRecent: boolean; formattedLastUpdateDate: string | null } => {
    const lastUpdateDate =
        lastUpdateTimestamp && lastUpdateTimestamp !== '0000-00-00 00:00:00'
            ? new Date(lastUpdateTimestamp)
            : null;

    const isLastUpdateRecent =
        lastUpdateDate && new Date().getTime() - lastUpdateDate.getTime() < daysToSeconds(2) * 1000;

    return {
        isLastUpdateRecent,
        formattedLastUpdateDate: lastUpdateDate
            ? formatDate(lastUpdateDate, 'dateTimeWithYear')
            : null,
    };
};
